// start:ng42.barrel
import   './components';
// end:ng42.barrel

